import { render } from "./AppNavigation.vue?vue&type=template&id=12adc50e&scoped=true"
import script from "./AppNavigation.vue?vue&type=script&lang=js"
export * from "./AppNavigation.vue?vue&type=script&lang=js"

import "./AppNavigation.vue?vue&type=style&index=0&id=12adc50e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12adc50e"]])

export default __exports__